<ng-container>
    <app-loader></app-loader>

    <app-toolbar *ngIf="currentUser" class="alternate-theme" (toggleSideNav)="toggleSideNavParent($event)" [sideNavOpened]="opened"></app-toolbar>
    
    <mat-sidenav-container class="mainContainer">
        <mat-sidenav #sidenav [(mode)]="over" [(opened)]="opened" class="sideNav" [fixedInViewport]="true" [fixedTopGap]="50" [fixedBottomGap]="0" *ngIf="currentUser">
            <mat-nav-list style="padding-top: 0">
                <a *ngFor="let item of menuItems" (click)="isMobile && sidenav.toggle()" mat-list-item routerLinkActive #routerLinkActiveInstance="routerLinkActive" [routerLinkActiveOptions]="{ exact: true }" [class.list-item-active]="routerLinkActiveInstance.isActive" [routerLink]="[item.route]" [class.disabled]="item.disabled">
                    <mat-icon matListIcon class="app-nav-list-icon">{{ item.icon }}</mat-icon>{{item.title}}  <!--<span matBadge="22" matBadgeColor="warn" matBadgeOverlap="false" matBadgeSize="medium">{{item.title}}</span>-->
                </a>
            </mat-nav-list>
        </mat-sidenav>

        <mat-sidenav-content [ngClass]="{ 'top50': currentUser, 'top0': !currentUser, 'loggedInHeight': currentUser }" class="mainContent">
            <router-outlet></router-outlet>
        </mat-sidenav-content>
    </mat-sidenav-container>

</ng-container>